<template>
  <div class="wrapper">
    <div
      style="backgroundImage: url(./img/wixbackground.png); background-size: cover; min-height: 93vh"
    >
      <NavbarBlack_fr />

      <div class="md-layout">
        <div
          class="md-layout-item md-size-100 md-small-100"
          style="height: 240px"
        >
          <br />
          <br />
        </div>
        <!-- <div class="md-layout-item md-size-15 md-small-hide"></div>
        <div class="md-layout-item md-size-30 md-small-size-100" style=" background-color: white; padding-left: 60px; padding-right: 70px;">

          <div style="text-align: center">
            <h4 slot="title" class="title" style="font-family: 'Roboto'; color:darkslateblue">
              Bonjour, utilisateurs de RPAS WILCO.
            </h4>
          </div>
          <h6 class="align-left">
            Merci pour votre soutien depuis 2019; ce fut un voyage incroyable pour nous de vous servir.
            Nous avons commencé notre voyage avec une bonne cause.
            Aider tous les pilotes RPAS à avoir un moyen facile de préparer des documents de vol pour les opérations de drones.
            Nous avons fait de notre mieux pour fournir des services de haute qualité au cours des trois dernières années, mais nous avons décidé de cesser notre service d’ici le 30 juin 2024.
            Par conséquent, nous suivrons les étapes ci-dessous:
          </h6>
           <ul style="font-size: 12px;">
              <li>
               Nous ne serons pas en mesure de prendre de nouvelles enrigistrements à partir du 31 janvier 2023.
              </li>
              <li>
                Le service pour les comptes gratuits s’arrêtera le 31 mars 2023.
                Par conséquent, veuillez conserver toute information de votre compte avant la date si nécessaire.
                Après le 31 mars, toutes vos données ne seront plus disponibles ainsi que votre connexion.
              </li>
              <li>
               Nous cesserons de renouveler le service payant après le 31 mai 2023.
               De cette façon, les abonnés payants actuels ne subiront aucune interruption de service.
              </li>
              <li>
               Après le 30 juin 2024, nous cesserons complètement nos services.
              </li>
              <li>
               Le service se concentrera sur les membres du MAAC seulement après le 30 juin 2024.
              </li>
           </ul>
           <h6 class="align-left">
            Je vous remercie encore une fois de votre soutien au cours des trois dernières années.<br /><br />
            Les conditions ci-dessus ne s’appliquent pas aux membres du MAAC.
           </h6>
        </div>
        <div class="md-layout-item md-size-5 md-small-hide"></div> -->
        <div class="md-layout-item md-size-35 md-small-hide"></div>
        <div
          class="md-layout-item md-size-30 md-small-size-100"
          style="text-align: center; background-color: white; padding-left: 60px; padding-right: 70px;"
        >
          <div style="text-align: center">
            <div
              slot="title"
              class="title"
              style="font-family: 'Roboto'; color:black;font-size: xxx-large;padding-top: 30px;"
            >
              {{ $t("Connexion") }}
            </div>
            <h4
              slot="title"
              class="title"
              style="font-family: 'Roboto'; color:darkslateblue"
            >
              Bienvenue chez RPAS WILCO
            </h4>
          </div>
          <br />
          <md-field class="md-form-group" slot="inputs">
            <md-icon>email</md-icon>
            <label>{{ $t("Adresse courriel") }}...</label>
            <md-input v-model="email" type="email"></md-input>
          </md-field>
          <md-field class="md-form-group" slot="inputs">
            <md-icon>lock_outline</md-icon>
            <label>{{ $t("Mot de passe") }}...</label>
            <md-input
              v-model="password"
              type="password"
              @keyup="keymonitor"
            ></md-input>
          </md-field>
          <br />
          <md-button slot="footer" class="md-primary md-block" @click="logon">{{
            $t("Se connecter")
          }}</md-button>
          <br />
          <md-button
            slot="footer"
            class="md-sm md-primary md-block"
            @click="forgotpassword"
            >{{ $t("Mot de passe oublié") }}</md-button
          >

          <br />
          <label class="text-danger">{{ $t(errorMsg) }}</label>
          <br />
          <br />
          <br />
        </div>
        <!-- <div class="md-layout-item md-size-15 md-small-hide"></div> -->
        <div class="md-layout-item md-size-35 md-small-hide"></div>
      </div>
    </div>

    <FooterBlack_fr />
  </div>
</template>
<script>
import FooterBlack_fr from "./Landing/Layout/FooterBlack_fr.vue";
import NavbarBlack_fr from "./Landing/Layout/NavbarBlack_fr.vue";
import { EventBus } from "@/helpers";

export default {
  components: {
    FooterBlack_fr,
    NavbarBlack_fr
  },
  name: "login_fr",
  bodyClass: "index-page",
  props: {
    logoImg: {
      type: String,
      default: "./img/logo-inverted.png"
    },
    img: {
      type: String,
      default: "./img/default-avatar.png"
    }
  },
  data() {
    return {
      email: null,
      password: null,
      errorMsg: "",
      scrollPosition: null,
      mobilescreen: false,
      language: "fr"
    };
  },
  computed: {
    setHeaderBgImage() {
      return {
        backgroundImage: `url(./img/background2x2.jpg)`
      };
    },
    setContactUsBgImage() {
      return {
        backgroundImage: `url(./img/bg-contactus.jpg)`
      };
    }
  },
  methods: {
    leafActive() {
      if (window.innerWidth < 768) {
        this.leafShow = false;
      } else {
        this.leafShow = true;
      }
    },
    keymonitor(event) {
      if (event.key === "Enter") {
        this.logon();
      }
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    logon() {
      this.$store.dispatch("auth/logon", {
        email: this.email,
        password: this.password
      });
    },
    forgotpassword() {
      this.$router.push("/forgotpassword_fr");
    },
    onResponsiveInverted() {
      if (window.innerWidth < 800) {
        this.mobilescreen = true;
      } else {
        this.mobilescreen = false;
      }
    }
  },
  mounted() {
    this.leafActive();
    window.addEventListener("resize", this.leafActive);
    document.addEventListener("scroll", this.updateScroll);
    EventBus.$on("failedLogon", msg => {
      this.errorMsg = msg;
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.leafActive);
    document.removeEventListener("scroll", this.updateScroll);
    EventBus.$off("failedLogon");
  }
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

.vertical-nav-active {
  display: block;
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
@media all and (max-width: 768px) {
  .vertical-nav-active {
    display: none;
  }
}

.mb-0 {
  padding-bottom: 0 !important;
}

#morphing-cards {
  padding-top: 70px;
}

.cd-section {
  height: 100vh;
}
.md-toolbar {
  background-color: rgba(0, 0, 0, 0.5);
}
.main-toolbar {
  position: fixed;
  z-index: 1000;
  left: 0;
  right: 0;
}
@media all and (min-width: 991px) {
  .hamburger {
    display: none;
  }
}
@media all and (max-width: 768px) {
  .main-toolbar {
    background-color: white;
  }
}
</style>
